import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export const useSurfSummary = () => {
	const { research } = useModuleData();
	const { viewModule } = useModuleNavigation();

	// 数据
	const summaryData = computed(() => {
		return research.data?.rows || [];
	});

	// 加载数据
	const loadSummaryData = async (params = {}) => {
		await research.refresh({
			...params,
			pagestart: params.pagestart,
			pagenum: params.pagenum
		});
	};

	const formatForOverview = item => {
		return {
			date: item.ptime || '',
			value: item.title || ''
		};
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('research', item);
	};

	// 是否为空
	const isEmpty = computed(() => {
		return research.empty || !summaryData.value.length;
	});

	return {
		research,
		summaryData,
		loadSummaryData,
		formatForOverview,
		handlePreview,
		isEmpty
	};
};
